exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-100px[data-v-65d866c0]{height:100px}.list-item[data-v-65d866c0]{color:rgba(0,0,0,.87)!important}.list-icon[data-v-65d866c0]{margin-right:16px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-65d866c0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NavigationMenu.vue
// module id = 820
// module chunks = 0